import { Injectable, inject } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable, catchError, of, shareReplay} from 'rxjs';
import {IdNome} from '../model/id-nome.model';
import {Usuario} from '../model/usuario/usuario.model';
import {UsuarioResumo} from '../model/usuario/usuario-resumo-model';
import { FiltrosUsuarioModel } from '../model/usuario/filtros-usuario.model';
import { PageModel } from '../model/page-mode.model';
import { ValidatorUsuarioModel } from '../model/usuario/validator-usuario.model';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {
  private readonly http = inject(HttpClient);

  urlBase = `${environment.urlBase}/usuario`

  salvarUsuario(usuario: Usuario): Observable<number> {
    return this.http.post<number>(this.urlBase, usuario);
  }

  buscarUsuariosPorPerfil(perfilId: number): Observable<IdNome[]> {
    return this.http.get<IdNome[]>(`${this.urlBase}/buscar/perfil/${perfilId}`);
  }

  buscarUsuariosPorEmail(email: string): Observable<Usuario[]> {
    return this.http.get<Usuario[]>(`${this.urlBase}/buscar/email/${email}`);
  }

  buscarUsuariosPorEmailEGrupo(email: string): Observable<Usuario[]> {
    return this.http.get<Usuario[]>(`${this.urlBase}/buscar/email/${email}/grupo`);
  }

  buscarUsuarioPeloAdEGrupo(texto: string): Observable<Usuario[]> {
    return this.http.get<Usuario[]>(`${this.urlBase}/buscar/ldap/${texto}/grupo`);
  }

  salvarOperador(operador: Usuario): Observable<number> {
    return this.http.post<number>(`${this.urlBase}/salvar/operador`, operador);
  }

  buscarOperadoresPorGrupo(): Observable<Usuario[]> {
    return this.http.get<Usuario[]>(`${this.urlBase}/buscar/operadores`);
  }

  buscarOperadoresPorGrupoECanal(canalId: number): Observable<IdNome[]> {
    return this.http.get<IdNome[]>(`${this.urlBase}/buscar/operadores/canal/${canalId}`);
  }

  buscarOperadoresPorGrupoComFiltro(filtros: FiltrosUsuarioModel): Observable<PageModel> {
    let params = new HttpParams()
        params = params.append('page', 0)
        params = params.append('limit' , 20)
    return this.http.post<PageModel>(`${this.urlBase}/buscar/operadores-com-filtro`, filtros, {
      headers: { 'no-loading': 'true' },
        params: params
    });
  }

  buscarUsuarios(grupoId?: number): Observable<UsuarioResumo[]> {
    let params = new HttpParams();
    if(grupoId){
      params = params.append('grupoId', grupoId);
    }

    return this.http.get<UsuarioResumo[]>(`${this.urlBase}/buscar`, { params });
  }

  buscarUsuariosResumoPaginado(filtro: FiltrosUsuarioModel, page: number, limit: number): Observable<PageModel> {
    return this.http.post<PageModel>(`${this.urlBase}/buscar-paginado`, filtro, {
      params: { page: page, limit: limit }
    });
  }

  buscarUsuariosPorGrupo(grupoId: number): Observable<UsuarioResumo[]> {
    return this.http.get<UsuarioResumo[]>(`${this.urlBase}/buscar/por-grupo-explicito/${grupoId}`);
  }

  buscarUsuarioComplete(usuarioId: number): Observable<Usuario> {
    return this.http.get<Usuario>(`${this.urlBase}/buscar/completo/${usuarioId}`);
  }

  buscarUsuarioAdPorEmail(email: string): Observable<Usuario[]> {
    return this.http.get<Usuario[]>(`${this.urlBase}/buscar/ad-por-email/${email}`);
  }

  validateUsuario(usuario: Usuario): Observable<ValidatorUsuarioModel> {
    return this.http.post<ValidatorUsuarioModel>(`${this.urlBase}/validar-usuarios`, usuario);
  }

  buscarUsuarioLogado(): Observable<Usuario> {
    return this.http.get<Usuario>(`${this.urlBase}/buscar/usuario-logado`);
  }

  private usuarioLogadoCache$?: Observable<Usuario | null>;

  buscarUsuarioLogadoEmCache(): Observable<Usuario | null> {
    this.usuarioLogadoCache$ ??= this.buscarUsuarioLogado().pipe(catchError(() => of(null)), shareReplay(1));
    return this.usuarioLogadoCache$;
  }

  verificarUsuarioCoordenador(usuarioId: number): Observable<boolean> {
    return this.http.get<boolean>(`${this.urlBase}/verificar-usuario-coordenador/${usuarioId}`);
  }

  uploadImgUsuario(usuario: Usuario): Observable<any> {
    return this.http.patch(`${this.urlBase}/trocar-img`,  usuario);
  }

  trocarSenhaUsuario(trocaSenha: any): Observable<any>{
    return this.http.patch(`${this.urlBase}/trocar-senha`,  trocaSenha);
  }

}
